import React from 'react';
import { BranchesOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';

import styles from './EnvironmentBanner.module.css';

type EnvironmentBannerMode = "staging" | "development" | "production" | "unknown";

export const getEnvironmentBannerMode = (metadata: Record<string, string>): EnvironmentBannerMode => {
  if (metadata['projectId']?.includes('staging')) {
    return 'staging';
  }
  if (metadata['databaseId']?.includes('development')) {
    return 'development';
  }

  // Prod
  if (metadata['projectId']?.includes('leedpulse') && metadata['databaseId']?.includes('(default)')) {
    return 'production';
  }

  return "unknown";  
}

export default function EnvironmentBanner({ mode }: { mode: EnvironmentBannerMode }) {
  if (mode === 'production') return null;
  const label = `${mode.toUpperCase()} MODE`;

  return (
    <Tooltip title={label}>
      <div
        className={classNames(styles['environmentBanner'], styles[`environmentBanner--${mode}`])}
      >
        <BranchesOutlined />
        <span>{label}</span>
      </div>
    </Tooltip>
  );
}
